export default __webpack_public_path__ + "static/media/product_card3_En.ab92de97.webp";